<template>
  <div class="video_button">
    <primary-button
      @click.native="openVideoModal"
      :link="false"
      :label="label"
			:type="'video'"
    ></primary-button>
  </div>
</template>

<script>
import PrimaryButton from './PrimaryButton.vue';
export default {
  data() {
    return {
      window: {
        width: 0,
        height: 0,
      },
    };
  },

  props: {
    video_source: {
      type: String,
      default: '',
    },
    link: {},
    label: {},
  },

  methods: {
    openVideoModal() {
      this.$store.commit('openVideoModal', this.video_source);
      document.body.classList.add('modal-open');
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
  },

  components: { PrimaryButton },

  created() {
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('load', this.handleResize);
    window.dispatchEvent(new Event('resize'));
    this.handleResize();
  },

  destroyed() {
    window.removeEventListener('resize', this.handleResize);
    this.handleResize();
  },

  mounted() {
    window.dispatchEvent(new Event('resize'));
    this.handleResize();
  },

  change() {
    window.dispatchEvent(new Event('resize'));
    this.handleResize();
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.video_button {
  // Styles for the button only - modal styles moved to SiteHeader
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/VideoButton.vue